// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"893":"ad4303e837df1630","8772":"f67a42c44f98523f"}[chunkId] + ".js";
};